// extracted by mini-css-extract-plugin
export default {"your_rd":"kx","title":"lx","subtitle":"mx","rd_bio_wrapper":"nx","rd_text_mobile":"ox","rd_bio":"px","img":"qx","rd_info":"rx","rd_name":"sx","rd_stat":"tx","rd_text":"ux","btn_mobile":"vx"};
    if(module.hot) {
      // 1715091678587
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  